import { Box, Stack, Typography } from "@mui/material";

export default function StepBlock({ number, title, subtitle, children }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ mb: 3.5 }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          bgcolor: "#2563eb",
          color: "#fff",
          display: "grid",
          placeItems: "center",
          fontWeight: 700,
          fontSize: 14,
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        {number}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, color: "#111827" }}>{title}</Typography>
        {subtitle ? (
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.25, mb: 1.5 }}>
            {subtitle}
          </Typography>
        ) : (
          <Box sx={{ mb: 1.5 }} />
        )}
        {children}
      </Box>
    </Stack>
  );
}
